export interface User {
  activatedAt?: string;
  activationSentAt?: string;
  disabledAt?: string;
  id: string;
  roleIds: [string];
  username: string;
  status?: string;
}

export enum UserStatuses {
  ACTIVE = 'Active',
  INACTIVE = 'Invite sent',
  DISABLED = 'Deactivated',
  INVITE_EXPIRED = 'Invite expired',
}
